import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAlert',
  setup(__props) {

const darkColor = defineAsyncComponent(() => import("@/components/theme/uikits/alert/darkColor.vue"))
const lightClor = defineAsyncComponent(() => import("@/components/theme/uikits/alert/lightClor.vue"))
const textAlert = defineAsyncComponent(() => import("@/components/theme/uikits/alert/textAlert.vue"))
const alertsSection = defineAsyncComponent(() => import("@/components/theme/uikits/alert/alertsSection.vue"))
const additionalContent = defineAsyncComponent(() => import("@/components/theme/uikits/alert/additionalContent.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Alert"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(darkColor)),
        _createVNode(_unref(lightClor)),
        _createVNode(_unref(textAlert)),
        _createVNode(_unref(alertsSection)),
        _createVNode(_unref(additionalContent))
      ])
    ])
  ], 64))
}
}

})